import {
	Button,
	FormControl,
	FormControlLabel,
	InputLabel,
	MenuItem,
	Select,
	Switch,
	Tooltip,
} from "@material-ui/core";
import { Forum, VerifiedUser } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import VisibilityIcon from "@material-ui/icons/Visibility";
import WarningIcon from "@material-ui/icons/Warning";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import {
	changeStatusCourse,
	deleteCourse,
	getCourses,
} from "../../../../api/course";
import { getSports } from "../../../../api/sport";
import { getUsers } from "../../../../api/user";
import { getNonEmpty } from "../../../../utils/helpers";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import FiltersCard from "../../../components/filters/Filter";
import Table, {
	badgeFormatter,
	buttonsStyle,
	dateFormatter,
} from "../../../components/tables/table";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250,
		},
	},
	getContentAnchorEl: () => null,
};

function getData(courses) {
	let data = [];
	for (let i = 0; i < courses.length; ++i) {
		const elem = {};
		elem.premium = courses[i].premium;
		elem.title = getNonEmpty(courses[i].title);
		elem.validation = {
			validated: courses[i].validated,
			valmess: courses[i].validationMessage,
		};
		elem.sport = getNonEmpty(courses[i]?.sport?.fullName);
		elem.level = courses[i].level;
		elem.description = courses[i].description;
		elem.createdBy = !courses[i].trainer
			? null
			: courses[i].trainer.fullName || "----";
		elem.createdAt = courses[i].createdAt;
		elem.id = courses[i]._id;
		elem.active = courses[i].active;
		elem.trainer = courses[i].trainer;
		elem.price = courses[i].price;
		data = data.concat(elem);
	}
	return data;
}

const initialFilters = {
	active: false,
	createdBy: [],
	standard: "All",
	level: "All",
	premium: false,
	validation: false,
	sport: [],
};

export default function CoursesPage() {
	const [data, setData] = useState([]);
	const [filteredData, setFilteredData] = useState([]);
	const [collapsed, setCollapsed] = useState(true);
	const [users, setUsers] = useState([]);
	const [sports, setSports] = useState([]);

	const [courseId, setCourseId] = useState(null);
	const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
	const [filterOptions, setFilterOptions] = useState(initialFilters);
	const [refresh, setRefresh] = useState(false);
	const history = useHistory();
	const user = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);

	function buttonFormatter(cell) {
		const elem = data.find((item) => item._id === cell);
		const canEdit =
			user?.role.includes("admin") || elem?.trainer === user?._id;
		return (
			<>
				<Tooltip title={canEdit ? "Edit" : "View"}>
					<Button
						style={buttonsStyle}
						size="small"
						onClick={() =>
							history.push("/sports/edit-course/" + cell)
						}
					>
						{canEdit ? <EditIcon /> : <VisibilityIcon />}
					</Button>
				</Tooltip>
				<Tooltip title={"View forum"}>
					<Button
						style={buttonsStyle}
						size="small"
						onClick={() =>
							history.push("/sports/courses/" + cell + "/threads")
						}
					>
						{<Forum />}
					</Button>
				</Tooltip>
				{canEdit && (
					<>
						<Tooltip title={elem?.active ? "Disable" : "Enable"}>
							<Button
								style={buttonsStyle}
								size="small"
								onClick={() => {
									setCourseId(elem);
									setOpenConfirmDialog(1);
								}}
							>
								{elem?.active ? (
									<ToggleOffIcon />
								) : (
									<ToggleOnIcon style={{ color: "red" }} />
								)}
							</Button>
						</Tooltip>
					</>
				)}
				{user?.role.includes("admin") && (
					<Tooltip title="Delete">
						<Button
							style={buttonsStyle}
							size="small"
							onClick={() => {
								setCourseId(cell);
								setOpenConfirmDialog(2);
							}}
						>
							<DeleteIcon />
						</Button>
					</Tooltip>
				)}
			</>
		);
	}

	function validationButton(cell) {
		return cell.validated ? (
			<VerifiedUser />
		) : (
			<>
				<Tooltip title={`${cell.valmess}`}>
					<Button style={buttonsStyle} size="small">
						<WarningIcon />
					</Button>
				</Tooltip>
			</>
		);
	}

	const columns = [
		{
			dataField: "premium",
			text: "",
			sort: true,
			formatter: (cell) =>
				cell ? (
					<img
						src={toAbsoluteUrl("/media/premium.png")}
						alt="premium"
						style={{ width: "25px", height: "25px" }}
					/>
				) : null,
			headerAlign: "center",
			align: "center",
		},
		{ dataField: "title", text: "Title", sort: true },
		{
			dataField: "validation",
			text: "Valid",
			sort: true,
			sortFunc: (a, b, order, dataField, rowA, rowB) => {
				if (order === "asc") return b.validated - a.validated;
				return a.validated - b.validated;
			},
			formatter: validationButton,
			headerAlign: "center",
			align: "center",
		},
		{
			dataField: "price",
			text: "Price",
			formatter: (cell) => cell? (cell+' €') : "N/A",
			align: "right",
			sort: true
		},
		{
			dataField: "level",
			text: "Level",
			sort: true,
			headerAlign: "center",
			align: "center",
		},
		{
			dataField: "sport",
			text: "Sport",
			sort: true,
			headerAlign: "center",
			align: "center",
		},
		{
			dataField: "createdBy",
			text: "Created by",
			sort: true,
			formatter: badgeFormatter,
			headerAlign: "center",
			align: "center",
		},
		{
			dataField: "createdAt",
			text: "Created at",
			formatter: dateFormatter,
			sort: true,
			headerAlign: "center",
			align: "center",
		},
		{ dataField: "id", text: "", formatter: buttonFormatter },
	];

	useEffect(() => {
		getUsers()
			.then((resp) => {
				if (resp.status === 200) {
					setUsers(
						resp.data.filter((item) =>
							item.role.includes("trainer")
						)
					);
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "Could not get users.",
				});
			});
		getSports()
			.then((res) => {
				if (res.status === 200) {
					setSports(res.data);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "Could not get sports.",
				});
			});
		getCourses()
			.then((res) => {
				if (res.status === 200) {
					setData(res.data);
					setFilteredData(res.data);
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "Could not get courses.",
				});
			});
	}, [refresh]);

	const handleSearch = async () => {
		if (!data.length) return;
		setFilteredData(
			data.filter((item) => {
				let filter = true;
				if (filterOptions.createdBy && filterOptions.createdBy.length)
					filter =
						filter &&
						filterOptions.createdBy.includes(item.createdBy);
				if (filterOptions.sport && filterOptions.sport.length)
					filter =
						filter &&
						filterOptions.sport.some((x) => item?.sport?._id === x);
				if (filterOptions.level && filterOptions.level !== "All")
					filter =
						filter &&
						filterOptions.level.toLowerCase() === item.level;
				if (
					filterOptions.standard &&
					filterOptions.standard !== "All"
				) {
					let condition = true;
					if (filterOptions.standard === "Custom")
						condition = item.trainer !== null;
					else if (filterOptions.standard === "Standard")
						condition = !item.trainer;
					filter = filter && condition;
				}
				if (filterOptions.premium) filter = filter && item.premium;
				if (filterOptions.active) filter = filter && item.active;
				if (filter) return item;
				return false;
			})
		);
	};

	const handleClearFilters = () => {
		setFilterOptions(initialFilters);
		setRefresh(true);
	};

	const handleChange = (element) => (event) => {
		setFilterOptions({ ...filterOptions, [element]: event.target.value });
	};

	const renderFiltersContent = () => {
		return (
			<>
				<FormControl style={{ width: "100%" }}>
					<InputLabel id="demo-simple-select-standard-label">
						Sport
					</InputLabel>
					<Select
						labelId="demo-simple-select-standard-label"
						id="demo-simple-select-standard"
						value={filterOptions.sport || []}
						multiple
						onChange={handleChange("sport")}
						MenuProps={MenuProps}
					>
						{sports?.map((option) => (
							<MenuItem key={option._id} value={option._id}>
								{getNonEmpty(option?.fullName)}
							</MenuItem>
						))}
					</Select>
				</FormControl>
				<br />
				<br />
				<FormControl style={{ width: "100%" }}>
					<InputLabel id="demo-simple-select-standard-label">
						Level
					</InputLabel>
					<Select
						labelId="demo-simple-select-standard-label"
						id="demo-simple-select-standard"
						value={filterOptions.level || ""}
						onChange={handleChange("level")}
						MenuProps={MenuProps}
					>
						{["All", "Beginner", "Intermediate", "Advanced"]?.map(
							(option) => (
								<MenuItem key={option} value={option}>
									{option}
								</MenuItem>
							)
						)}
					</Select>
				</FormControl>
				<br />
				<br />
				<FormControl style={{ width: "100%" }}>
					<InputLabel id="demo-simple-select-standard-label">
						Standard
					</InputLabel>
					<Select
						labelId="demo-simple-select-standard-label"
						id="demo-simple-select-standard"
						value={filterOptions.standard || ""}
						onChange={handleChange("standard")}
						MenuProps={MenuProps}
					>
						{["All", "Standard", "Custom"]?.map((option) => (
							<MenuItem key={option} value={option}>
								{option}
							</MenuItem>
						))}
					</Select>
				</FormControl>
				<br />
				<br />
				<FormControl style={{ width: "100%" }}>
					<InputLabel id="demo-simple-select-standard-label">
						Created by
					</InputLabel>
					<Select
						labelId="demo-simple-select-standard-label"
						id="demo-simple-select-standard"
						value={filterOptions.createdBy || []}
						multiple
						onChange={handleChange("createdBy")}
						MenuProps={MenuProps}
					>
						{users?.map((option) => (
							<MenuItem key={option._id} value={option._id}>
								{option.fullName}
							</MenuItem>
						))}
					</Select>
				</FormControl>
				<br />
				<br />
				<FormControlLabel
					control={
						<Switch
							checked={filterOptions.premium}
							onChange={() =>
								setFilterOptions({
									...filterOptions,
									premium: !filterOptions.premium,
								})
							}
							name="checkPremium"
						/>
					}
					label={
						filterOptions.premium
							? "Only premium"
							: "All premium/free"
					}
				/>
				<br />
				<FormControlLabel
					control={
						<Switch
							checked={filterOptions.active}
							onChange={() =>
								setFilterOptions({
									...filterOptions,
									active: !filterOptions.active,
								})
							}
							name="checkActive"
						/>
					}
					label={
						filterOptions.active
							? "Only active"
							: "All active/inactive"
					}
				/>
			</>
		);
	};

	return (
		<>
			<Card>
				<CardHeader title="Courses list">
					<CardHeaderToolbar>
						<button
							type="button"
							className="btn btn-primary"
							onClick={() => history.push("/sports/edit-course")}
						>
							Add new
						</button>
					</CardHeaderToolbar>
				</CardHeader>
				<CardBody>
					<FiltersCard
						filtersContent={renderFiltersContent}
						collapsed={collapsed}
						setCollapsed={setCollapsed}
						handleClearFilters={handleClearFilters}
						handleSearch={handleSearch}
					/>

					<Table data={getData(filteredData)} columns={columns} />

					<ConfirmDialog
						title={`Are you sure you want to ${
							courseId?.active ? "disable" : "enable"
						} this course?`}
						open={openConfirmDialog === 1}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							changeStatusCourse(courseId._id, !courseId?.active)
								.then((res) => {
									if (res.status === 200) {
										alertSuccess({
											title: `${
												courseId?.active
													? "Disabled!"
													: "Enabled!"
											}`,
											customMessage: `Course ${
												courseId?.active
													? "disabled"
													: "enabled"
											} successfully`,
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage: `Could not ${
											courseId?.active
												? "disable"
												: "enable"
										} course.`,
									});
								});
						}}
					/>
					<ConfirmDialog
						title={"Are you sure you want to remove this course?"}
						open={openConfirmDialog === 2}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							deleteCourse(courseId)
								.then((res) => {
									if (
										res.status === 204 ||
										res.status === 200
									) {
										alertSuccess({
											title: "Deleted!",
											customMessage:
												"Course removed successfully.",
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage:
											"Could not remove course.",
									});
								});
						}}
					/>
				</CardBody>
			</Card>
		</>
	);
}
